import { lazy, useEffect, useRef } from "react"

/**
 * lazyImport พร้อม method preload และ hook preload เมื่อมองเห็น
 */
const lazyImport = (importFunc) => {
  let hasPreloaded = false
  const Component = lazy(importFunc)

  const preload = () => {
    if (!hasPreloaded) {
      hasPreloaded = true
      importFunc()
        .then(() => {
          if (process.env.NODE_ENV === "development") {
            // console.log("[lazyImport] Preloaded:", importFunc.toString())
          }
        })
        .catch((err) => {
          // console.error("[lazyImport] preload error:", err)
        })
    }
  }

  /**
   * Hook: เรียก preload ทันทีเมื่อ component เข้ามาใน viewport
   * @returns {React.MutableRefObject}
   */
  const usePreloadOnVisible = () => {
    const ref = useRef()

    useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          preload()
          observer.disconnect()
        }
      })

      if (ref.current) observer.observe(ref.current)

      return () => observer.disconnect()
    }, [])

    return ref
  }

  return {
    Component,
    preload,
    usePreloadOnVisible,
  }
}

export default lazyImport